import { useEffect, useState } from "react";
import { Tabs, Tab, Card, CardBody, CardHeader } from "@nextui-org/react";
import RajhanshImg from "../assats/Rajhans Empire office-2.webp";
import tejaniImg from "../assats/Tejani.webp";
import royalton from "../assats/RajhansRoyalTon.webp";
import AvadhImg from "../assats/Avadh.webp";
import gallary1 from "../assats/gallary1.webp";
import gallary2 from "../assats/gallary2.webp";
import gallary3 from "../assats/gallary3.webp";
import gallary4 from "../assats/gallary4.webp";
import gallary5 from "../assats/gallary5.webp";
import gallary6 from "../assats/gallary6.webp";
import gallary7 from "../assats/gallary7.webp";
import gallary8 from "../assats/gallary8.webp";
import gallary9 from "../assats/gallary9.webp";
import gallary10 from "../assats/gallary10.webp";
import gallary11 from "../assats/gallary11.webp";
import gallary12 from "../assats/gallary12.webp";
import gallary13 from "../assats/gallaryImg/g11.jpg";
import gallary14 from "../assats/gallaryImg/g1.jpg";
import gallary15 from "../assats/gallaryImg/g2.jpg";
import gallary16 from "../assats/gallaryImg/g3.jpg";
import gallary17 from "../assats/gallaryImg/g4.jpg";
import gallary18 from "../assats/gallaryImg/g5.jpg";
import gallary19 from "../assats/gallaryImg/g6.jpg";
import gallary20 from "../assats/gallaryImg/g7.jpg";
import gallary21 from "../assats/gallaryImg/g8.jpg";
import gallary22 from "../assats/gallaryImg/g9.jpg";
import gallary23 from "../assats/gallaryImg/g10.jpg";
import gallary24 from "../assats/gallaryImg/g11.jpg";
import gallary25 from "../assats/gallaryImg/g12.jpg";


import axios from "axios";
import { API_URL } from "../config";
import { useNavigate } from "react-router-dom";
const Projects = () => {
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState('all');
    // const [isToken, setToken] = useState();
    const [allProject, setallProject] = useState([]);
    const [architectureProject, setArchitectureProject] = useState([]);
    const [interiorProject, setInteriorProject] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    // const TokenData = JSON.stringify(isToken);


    // Data for images
    const allData = [
        {
            id: 1,
            src: RajhanshImg,
            alt: 'Image 1'
        },
        {
            id: 2,
            src: tejaniImg,
            alt: 'Image 2'
        },
        {
            id: 3,
            src: royalton,
            alt: 'Image 3'
        },
        {
            id: 3,
            src: AvadhImg,
            alt: 'Image 4'
        }
    ];
    const First = [
        {
            id: 1,
            src: RajhanshImg,
            alt: 'Image 1'
        },
        {
            id: 2,
            src: tejaniImg,
            alt: 'Image 2'
        }
    ];
    const Second = [
        {
            id: 1,
            src: royalton,
            alt: 'Image 1'
        },
        {
            id: 2,
            src: AvadhImg,
            alt: 'Image 2'
        },
    ];
    // useEffect(() => {
    //     const token = localStorage.getItem("JWT_Token");
    //     setToken(token);
    // }, [])

    const ViewAllPost = () => {

        const post_type = "interior";
        const url = `${API_URL}/admin/post/view_post/?title=`;
        const token = localStorage.getItem("JWT_Token");

        // const config = {
        //     headers: {
        //         Authorization: `Bearer ${token}`
        //     }
        // };

        axios.get(url)
            .then(response => {
                setallProject(response.data.record);
            })
            .catch(error => {
                // Handle error
                console.error("Error:", error.response.status, error.response.statusText);
                console.error(error.response.data);
            });
    }
    useEffect(() => {
        ViewAllPost();
    }, [])

    // Function to handle tab click
    const handleTabClick = (tab) => {
        setActiveTab(tab);

        if (tab === "architecture") {
            const post_type = "interior";
            const url = `${API_URL}/admin/post/view_architecture_post/?post_type=architecture`;
            const token = localStorage.getItem("JWT_Token");
            // const config = {
            //     headers: {
            //         Authorization: `Bearer ${token}`
            //     }
            // };

            axios.get(url)
                .then(response => {
                    setArchitectureProject(response.data.record);
                })
                .catch(error => {
                    console.error("Error:", error.response.status, error.response.statusText);
                    console.error(error.response.data);
                });
        } else if (tab === "interior") {
            const post_type = "interior";
            const url = `${API_URL}/admin/post/view_interior_post/?post_type=interior`;
            const token = localStorage.getItem("JWT_Token");

            // const config = {
            //     headers: {
            //         Authorization: `Bearer ${token}`
            //     }
            // };

            axios.get(url)
                .then(response => {
                    setInteriorProject(response.data.record);
                })
                .catch(error => {
                    console.error("Error:", error.response.status, error.response.statusText);
                    console.error(error.response.data);
                });
        } else {
            console.log("All Data");
        }
    };
    return (
        <>
            <div className="lg:container md:mx-auto px-5 py-10 ">
                <div className="flex justify-center mb-16">
                    <p className="text-[32px]  border-b-4  tracking-wider border-[#A35733]">Our Portfolio</p>
                </div>
                <p className="text-center mb-5 tracking-wider">DesignCore Studio wants your space to be your favourite spot in the whole wide world. We understand that every space can look completely different with the right design. Our team of designers are here to tailor your space’s perfect look and make it as interesting as you are.</p>
                <p className="text-center tracking-wider">
                    We invite you to view some of our most amazing projects. Our team at DesignCore Studio are experts at freshening up places and unlocking their full potential. Here are just a few of our projects.
                </p>
            </div>
            <div className="">
                <div className="flex justify-center">
                    <button className={`tab-button tracking-wider rounded-lg ${activeTab === 'all' ? 'active' : ''}`} onClick={() => handleTabClick('all')}>All</button>
                    <button className={`tab-button tracking-wider rounded-lg  ${activeTab === 'architecture' ? 'active' : ''}`} onClick={() => handleTabClick('architecture')}>Architecture</button>
                    <button className={`tab-button tracking-wider rounded-lg ${activeTab === 'interior' ? 'active' : ''}`} onClick={() => handleTabClick('interior')}>Interior Design</button>
                </div>

                <div className="flex justify-center mt-16 ">
                    <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row gap-10">
                        {activeTab === 'all' ?
                            allProject.map((item, index) => {
                                return (
                                    <>
                                        <div
                                            key={index}
                                            className="image-container"
                                            onMouseEnter={() => setHoveredIndex(index)}
                                            onMouseLeave={() => setHoveredIndex(null)}
                                            onClick={() => navigate(`/detail/${item._id}`)}
                                        >
                                            <img src={`${API_URL}${item.postImage}`} alt="" className="image w-80 h-80" />
                                            {hoveredIndex === index && (
                                                <div className="overlay">
                                                    <p className="overlay-text">{item.title}</p>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )
                            })
                            : activeTab === 'architecture' ?
                                architectureProject.map((item, index) => {
                                    return (
                                        <>
                                            {/* <div
                                                key={index}
                                                className="image-container"
                                                onMouseEnter={() => setHoveredIndex(index)}
                                                onMouseLeave={() => setHoveredIndex(null)}
                                                onClick={() => navigate(`/detail/${item._id}`)}>
                                                <img src={`${API_URL}${item.postImage}`} alt="" className="image h-full" />
                                                {hoveredIndex === index && (
                                                    <div className="overlay">
                                                        <p className="overlay-text">{item.title}</p>
                                                    </div>
                                                )}
                                            </div> */}
                                            <div
                                                key={index}
                                                className="image-container"
                                                onMouseEnter={() => setHoveredIndex(index)}
                                                onMouseLeave={() => setHoveredIndex(null)}
                                                onClick={() => navigate(`/detail/${item._id}`)}>
                                                <img src={`${API_URL}${item.postImage}`} alt="" className="image w-80 h-80" />
                                                {hoveredIndex === index && (
                                                    <div className="overlay">
                                                        <p className="overlay-text">{item.title}</p>
                                                    </div>
                                                )}
                                            </div>

                                        </>
                                    )
                                }) : activeTab === 'interior' ?
                                    interiorProject.map((item, index) => {
                                        return (
                                            <>
                                                {/* <div>
                                                    <div className="transition ease-in-out delay-100 h /over:-translate-y-1 hover:scale-110 duration-100 cursor-pointer" >
                                                        <img src={`${API_URL}${item.postImage}`} alt="" />
                                                    </div>
                                                    <p className="text-center font-semibold text-[18px] mt-8">{item.title}</p>
                                                </div> */}
                                                <div
                                                    key={index}
                                                    className="image-container"
                                                    onMouseEnter={() => setHoveredIndex(index)}
                                                    onMouseLeave={() => setHoveredIndex(null)}
                                                    onClick={() => navigate(`/detail/${item._id}`)}>
                                                    <img src={`${API_URL}${item.postImage}`} alt="" className="image w-80 h-80" />
                                                    {hoveredIndex === index && (
                                                        <div className="overlay">
                                                            <p className="overlay-text">{item.title}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )
                                    }) : ''
                        }
                    </div>
                </div>
            </div>
            <div className="lg:container md:mx-auto px-5 py-10 mt-16 ">
                <p className="text-[32px] pl-3 pb-5">And Many More</p>
                <div className="row">
                    <div className="column">
                        {/* <SlideshowLightbox className="column"> */}
                        <img src={gallary12} style={{ width: "100%" }} />
                        <img src={gallary2} style={{ width: "100%" }} />
                        <img src={gallary3} style={{ width: "100%" }} />
                        <img src={gallary4} style={{ width: "100%" }} />
                        <img src={gallary5} style={{ width: "100%" }} />
                        <img src={gallary6} style={{ width: "100%" }} />
                        <img src={gallary7} style={{ width: "100%" }} />
                        <img src={gallary24} style={{ width: "100%" }} />
                        {/* </SlideshowLightbox> */}
                    </div>
                    <div className="column">
                        <img src={gallary8} style={{ width: "100%" }} />
                        <img src={gallary9} style={{ width: "100%" }} />
                        <img src={gallary10} style={{ width: "100%" }} />
                        <img src={gallary11} style={{ width: "100%" }} />
                        <img src={gallary12} style={{ width: "100%" }} />
                        <img src={gallary1} style={{ width: "100%" }} />
                        <img src={gallary25} style={{ width: "100%" }} />
                    </div>
                    <div className="column">
                        <img src={gallary13} style={{ width: "100%" }} />
                        <img src={gallary14} style={{ width: "100%" }} />
                        <img src={gallary15} style={{ width: "100%" }} />
                        <img src={gallary16} style={{ width: "100%" }} />
                        <img src={gallary17} style={{ width: "100%" }} />
                        <img src={gallary18} style={{ width: "100%" }} />
                    </div>
                    <div className="column">
                        <img src={gallary20} style={{ width: "100%" }} />
                        <img src={gallary21} style={{ width: "100%" }} />
                        <img src={gallary22} style={{ width: "100%" }} />
                        <img src={gallary23} style={{ width: "100%" }} />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Projects;